import React, { useState } from 'react';
import { WiDaySunny } from 'react-icons/wi';
import { MdOutlineModeNight } from 'react-icons/md';
import { FiLogOut } from 'react-icons/fi'
function Header({ mode, toggleMode, user, handleLogout }) {
  const [showLogout, setShowLogout] = useState(false);

  const headerTextColor = mode === 'night' ? 'text-white' : 'text-gray-700';

  const handleLogoutBtn = () => {
    setShowLogout(!showLogout)
  }
  return (
    <header
      className={`p-9 ${headerTextColor}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <img
            src="bot.jpg"
            alt="logo"
            className="w-8 h-8 lg:w-12 lg:h-12 rounded-full mr-4"
          />
          <p className="font-bold text-sm lg:text-xl">AI Chat</p>
        </div>

        {user?.username && (
          <div className="flex items-center">
            <div
              className="group relative cursor-pointer"
              onClick={() => handleLogoutBtn()}
            >
              <div className='flex '>
              <img
                src="user.png"
                alt="User"
                className="w-8 h-8 lg:w-12 lg:h-12 rounded-full mr-4"
              />
              <p className="font-bold text-sm hidden sm:block lg:text-xl my-2">
                {user?.username}
              </p>
              </div>
              {showLogout && (
                <div className={`absolute block ${mode === 'night' ? 'bg-gray-700 text-gray-100' : 'bg-gray-300 text-gray-700'} px-2 py-1 mt-2 rounded shadow-md`}>
                  <p onClick={() => handleLogout()} className="cursor-pointer flex">
                    Logout <span className={'my-auto ml-2'}><FiLogOut /></span>
                  </p>
                </div>
              )}
            </div>
          </div>
        )}

        <button
          onClick={toggleMode}
          className={`bg-blue-500 text-white px-2 py-1 rounded text-xl`}
        >
          {mode === 'night' ? <WiDaySunny /> : <MdOutlineModeNight />}
        </button>
      </div>
    </header>
  );
}

export default Header;
